const DEBUG = false;

export const hostsInstitutional = {
  // 127.0.0.1, not localhost: the sandbox shim binds IPv4 only, and Chrome
  // resolves localhost to ::1 first without falling back -> Failed to fetch
  development: "http://localhost:8000",
  test: "https://backend.dev.crosspoint.global",
  production: "https://ridian-api-193751933898.us-central1.run.app",
};

export const hostsWebSocket = {
  development: "wss://localhost:8000",
  test: "wss://backend.dev.crosspoint.global",
  production: "wss://ridian-api-193751933898.us-central1.run.app",
};

// The compliance engine serves the Leads CRM until the institutional backend
// implements /leads and fans out to it (see api/compliance). No production
// deployment exists yet — production deliberately points nowhere so a prod
// build cannot silently talk to the dev sandbox.
export const hostsCompliance = {
  development: "http://localhost:8787",
  test: "https://crosspoint-compliance.dev.crosspoint.global",
  production: "https://crosspoint-compliance.crosspoint.global",
};

const loginContent = [
  {
    name: "sign-in",
    msg: ["signin_title", "signin_use_credentials"],
  },
  {
    name: "sign-up",
    msg: ["sign_up_create_account", "sign_up_today"],
  },
  {
    name: "recover",
    msg: ["forgot_password_label", "forgot_password_use_credentials"],
  },
];

const timeFrames = [
  { label: "dashboard_period_1_day", value: "1_day", default: true },
  { label: "dashboard_period_1_week", value: "1_week" },
  { label: "dashboard_period_1_month", value: "1_month" },
  { label: "dashboard_period_3_months", value: "3_months" },
  { label: "dashboard_period_1_year", value: "1_year" },
  { label: "dashboard_period_all", value: "all" },
];

const defaultDate = new Date(Date.now());
export const defaultDataPoints = [
  {
    key: new Date(new Date().setDate(defaultDate.getDate() - 1)),
    value: 0,
  },
  {
    key: defaultDate,
    value: 0,
  },
];

const recaptchaSitesKey = "6Lca3K8iAAAAAHuDv8TJoCBCR4MJs8CZVBt7hIYm";

export { DEBUG, loginContent, timeFrames, recaptchaSitesKey };
